<template>
<v-container>

    <h2>Inboxes</h2>

    <m-edit-chip
        label="Have the widget offer help with (inboxes)"
        dialog_title="Inboxes"
        v-model="cur_inboxes"
        :possible_values="inboxes"
    />

    <m-edit-text
        label="Show On URL"
        v-model="show_on_url"
        style="margin-top: 15px;"
        optional
    />

    <div
        style="text-align: right"
        v-on:click="onClickShowTestPage"
    >
        <v-btn
            color="primary"
        >
            Open Test Widget Page In New Window
        </v-btn>
    </div>

</v-container>
</template>

<script>
export default 
{
    props: {
        organization_id: {
            type: String,
            default: function() { return null; }
        },
        settings_id: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            profile: {},

            inboxes: [],
            cur_inboxes: [],
            show_on_url: null,
        }
    },

    mounted () 
    {
        this.$rc.showSpinner();
        
        this.$rc.rest(
            'LIST-LABELS: /api/v1/inboxes',
        
            {
                'organization_id' : this.organization_id,
                'is_archived': false,
            },
        
            (data) => {
                this.$rc.hideSpinner();

                let inboxes = [];

                for ( let i = 0; i < data.results.length; i++ )
                {
                    inboxes.push({
                        'text' : data.results[i].help_with,
                        'organization_id' : data.results[i].organization_id,
                        'inbox_id' : data.results[i].inbox_id,
                    })
                }

                if ( inboxes.length > 0 )
                    this.cur_inboxes = [inboxes[0]];

                this.inboxes = inboxes;
                },
        
            () => {
                this.$rc.hideSpinner();
                this.$rc.alert('Error','Unable to complete API call');
            },
        );
    },

    methods: 
    {
        onClickShowTestPage()
        {
            window.open(this.getWidgetURL(), "_blank"); 
        },

        getWidgetURL() 
        {
            let settings_id_part = '';

            if ( this.settings_id != null )
                settings_id_part = 'widget_settings_id='+this.settings_id+"&";

            let query_string = '?'+settings_id_part+'inbox_ids='+encodeURIComponent(this.meta_inbox_ids)+'&ref='+encodeURIComponent(window.location.href);

            let url = this.show_on_url;

            if ( url != null && url.trim().length > 0 )
            {
                url = url.trim();

                if ( !url.toLowerCase().startsWith('http') )
                {
                    url = 'https://'+url;
                }

                query_string += '&bkg_url='+encodeURIComponent(url);
            }

            return this.$rc.getAPIEndpoint('widget/test-website-page.html')+query_string;
        },
    },

    computed: {
        meta_inbox_ids() 
        {
            let ret = '';

            for ( let i = 0; i < this.cur_inboxes.length; i++ )
            {
                if ( ret.length != 0 )
                    ret += '; ';
                
                ret += this.cur_inboxes[i].organization_id + ':' + this.cur_inboxes[i].inbox_id;
            }

            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>